// This is just some sample data so you don't have to think of your own!
const posts = {
  post1: {
    place: "Argentina",
    image: "/images/argentina-me-penyboard.jpg",
    desc:
      "Traveling Argentina with my little penny board :) #skateboard #boards #skateboarding #argentina #buenosaires #laboca",
    year: 2015
  },

  post2: {
    place: "Argentina",
    image: "/images/argentina-salt-lake.jpg",
    desc:
      "Salinas Grandes :) #travellingargentina #ilzetraveling #argentina",
    year: 2015
  },

  post3: {
    place: "Austria",
    image: "/images/austria-me-board.jpg",
    desc:
      "Amazing views ☺️ #snowboarding #snowboard #wonder #Salomon #ilzetraveling",
    year: 2016
  },

  post4: {
    place: "Costa Rica",
    image: "/images/costa-rica-girls.jpg",
    desc:
      "Live in the sunshine, swim in the sea, drink the wild air! Pura vida ❤️ #ilzetraveling #costaricalife #backpacking #latvianincostarica #oceanlife #livingthegoodlife",
    year: 2019
  },

  post5: {
    place: "Costa Rica",
    image: "/images/costa-rica-surf.jpg",
    desc:
      "Santa Teresa, feels like I’m in burning man festival just plus surfing 🏄🏼‍♀️ the amount of dust is just crazy 😝 still love the place 😘 #ilzetraveling #latvianincostarica #costaricalife #gonesurfing #surfergirls #hangingoutwithfinland",
    year: 2019
  },

  post6: {
    place: "Costa Rica",
    image: "/images/costa-rica-watermelon.jpg",
    desc:
      "Colours of Costa Rica 🇨🇷 #ilzetraveling #latvianincostarica #costaricalife #coloursofsummer #livingthegoodlife",
    year: 2019
  },

  post7: {
    place: "Hawaii",
    image: "/images/hawaii-blending-in.jpg",
    desc: "Blending in 🤓 #hawaiilife #latvianinhawaii #ilzetraveling #mauilife",
    year: 2018
  },

  post8: {
    place: "Hawaii",
    image: "/images/hawaii-broken-leg.jpg",
    desc:
      "#poollife 😎 #ilzetraveling #latvianinhawaii #hawaiilife #bigislandlife #livingthegoodlife",
    year: 2018
  },

  post9: {
    place: "Hawaii",
    image: "/images/hawaii-dearty-feet.jpg",
    desc:
      "Hana mud hike 😱 who needs shoes chasing those waterfalls 😂 #girlfromcountryside #ilzetraveling #latvianinhawaii #hawaiilife #livingthegoodlife",
    year: 2018
  }
};

export default posts;
